<div class="display-element">
  <menu-bar></menu-bar>
</div>
<mat-divider></mat-divider>
<div class="display-element">
  <content-container fxFlex></content-container>
</div>
